import { useEffect, useRef } from 'react'

/**
 * Hook to ensure file links open in new tab
 * @param content - HTML content string
 */
export const useFileLinksTarget = (content: string) => {
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (ref.current && content) {
      // 尋找所有檔案連結並設置為新視窗開啟
      const fileLinks = ref.current.querySelectorAll('a[href*="/uploads/files/"]')
      fileLinks.forEach((link: Element) => {
        const htmlLink = link as HTMLAnchorElement
        htmlLink.setAttribute('target', '_blank')
        htmlLink.setAttribute('rel', 'noopener noreferrer')
        
        // 添加一些視覺提示，表示這是外部連結
        if (!htmlLink.querySelector('.external-link-icon')) {
          const icon = document.createElement('span')
          icon.className = 'external-link-icon ml-1 text-xs text-gray-400'
          icon.innerHTML = '↗'
          icon.title = '在新視窗開啟'
          htmlLink.appendChild(icon)
        }
      })

      // 處理圖片連結
      const imageLinks = ref.current.querySelectorAll('a[href*="/uploads/images/"]')
      imageLinks.forEach((link: Element) => {
        const htmlLink = link as HTMLAnchorElement
        htmlLink.setAttribute('target', '_blank')
        htmlLink.setAttribute('rel', 'noopener noreferrer')
      })
    }
  }, [content])

  return ref
}

export default useFileLinksTarget